import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { DummyNodeModel } from './DummyNodeModel';
import { DummyNodeWidget } from './DummyNodeWidget';

export class DummyNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.Dummy);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new DummyNodeModel();
  }

  nodeUI(event) {
    return <DummyNodeWidget engine={this.engine} node={event.model} width={20} height={20} />;
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()} isDummy>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
